(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $block.find(".text-link").matchHeight({
        property: "min-height",
        byRow: false,
      });
    }
    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);
  };

  $(document).ready(function () {
    $(".block--text-links").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=text-links",
      initializeBlock
    );
  }
})(jQuery);
